/**
 * 判断url是否是http或https 
 * @param {string} path
 * @returns {Boolean}
 */
 export function isHttp(url) {
  return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1
}

/**
 * 判断path是否为外链
 * @param {string} path
 * @returns {Boolean}
 */
 export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * 校验小版本号格式：大版本号(8位) + 自定义序号(8位) = 16位纯数字
 * @param {string} value 输入的16位小版本号
 * @param {string} majorVersion 固件大版本号(8位)
 * @returns {{ valid: boolean, message: string }}
 */
export function validateSubVersion(value, majorVersion) {
  if (!value) {
    return { valid: false, message: '请输入整机固件小版本' }
  }
  const str = String(value)
  if (str.length !== 14) {
    return { valid: false, message: `小版本号必须为14位纯数字，当前长度为${str.length}位` }
  }
  if (!/^\d{14}$/.test(str)) {
    return { valid: false, message: '小版本号必须全部由数字(0-9)组成，不允许包含字母、符号或空格' }
  }
  if (majorVersion && str.slice(0, 11) !== majorVersion.slice(0, 11)) {
    return { valid: false, message: `小版本号前11位必须与固件大版本号(${majorVersion})前11位一致` }
  }
  return { valid: true, message: '' }
}

/**
 * Element Plus 表单 validator 适配函数
 * @param {string} majorVersion 固件大版本号
 * @returns {(rule: any, value: string, callback: Function) => void}
 */
export function createSubVersionValidator(majorVersion) {
  return (rule, value, callback) => {
    const result = validateSubVersion(value, majorVersion)
    if (result.valid) {
      callback()
    } else {
      callback(new Error(result.message))
    }
  }
}
